import {redirect, Navigate } from "react-router-dom";
import {localStorageAdminKey} from '../local_storage_vars';
import { smartStorage } from "../smart_storage";
 
const AdminAuthRequired = ({children})=>{
    const user = smartStorage.get(localStorageAdminKey); 
    if(!user){
        return <Navigate to={'/login'} />
    }else{
        return children;
    }
}

export default AdminAuthRequired